module.exports = require("./bas-CM");